<ng-container *transloco="let t">
  <h2>{{t('maximumQuestsCreated')}}</h2>
  <div>{{t('onlyNQuests')}}</div>
  <button class="primary-btn margin-top-18" style="width: 200px" (click)="navToHome()">{{t('goHome')}}</button>
</ng-container>
